import { signIn, signUp, confirmSignUp, getCurrentUser, signOut, autoSignIn, fetchAuthSession, fetchUserAttributes, resetPassword, confirmResetPassword, resendSignUpCode } from 'aws-amplify/auth';

export async function authenticate ( email, password )
{
    return signIn ( { username: email, password: password } );
}

export async function register ( email, password, location, region, team )
{
    await unauthenticate ();

    const result = await signUp ( {
                                username: email,
                                password: password,
                                options: {
                                    userAttributes: {
                                        email: email,
                                        'custom:location': location,
                                        'custom:region': region,
                                        'custom:team': team,
                                    },
                                    autoSignIn: true
                                }
                            } );
    console.log ( result );
    return result;
}

export async function registerConfirmation ( email, code )
{
    const result = await confirmSignUp ( {
                                username: email,
                                confirmationCode: code
                            } );

    let isSignedIn = false;

                            console.log ( "CONFIRM CODE" );
                            console.log ( result );

    if ( result.isSignUpComplete === true )
    {
        const signInOutput = await autoSignIn ();
        isSignedIn = signInOutput.isSignedIn;
    }

    return { isSignUpComplete: result.isSignUpComplete, isSignedIn: isSignedIn };
}

export async function getAuthenticatedUser ()
{
    const result = await getCurrentUser  ();
    console.log ( result );
    return result;
}

export async function unauthenticate ()
{
    const user = await signOut ();
    return user;
}

export async function getAuthenticatedSession ()
{
    const { accessToken, idToken } = ( await fetchAuthSession () ).tokens ?? {};
    return { aaccessToken: accessToken, idToken: idToken };
}

export async function authenticatedSessionHasRole ( role )
{
    const session = await getAuthenticatedSession ();

    var token = session.idToken;

    if ( !token ) return false;

    var groups = token.payload['cognito:groups'];
    return groups && groups.includes ( role );
}

export async function getCustomAttributes ()
{
    return await fetchUserAttributes ();
}

export async function sendResetPasswordCode ( email )
{
    const result = await resetPassword ( { username: email } );
    console.log ( result );
    return result;
}

export async function submitResetPassword ( email, newPassword, code )
{
    const result = await confirmResetPassword ( { username: email, newPassword: newPassword, confirmationCode: code } );
    console.log ( "RESET PASSWORD OUTCOME" );
    console.log ( result );
    return result;
}

export async function resendConfirmationCode ( email )
{
    await resendSignUpCode ( {
                                username: email                              
                            }  );
    return;
}